export default function AlertBox({ alert, validator }) {
  return alert !== "" ? (
    <div
      className={validator ? "alert alert-success" : "alert alert-danger"}
      role="alert">
      {alert}
    </div>
  ) : (
    ""
  );
}
